import { FaShieldAlt, FaExclamation, FaUser, FaLaptop } from "react-icons/fa";
import Card from "components/Card/Card";
import "../../screen/landing/LandingPage.css"
export const Marketing = () => {

    return (

      <div className="card-group-container">
      <div className="landing-page-child-1">
        <div className="card-child">
          <Card
            icon={<FaShieldAlt size={80}/>} // Pass the 'X' icon (you can replace with an SVG)
            title="Pay as you master"
            subtitle="No Strings Attached – Pay Only for the Tracks You Master!"
            variant="tertiary"
          />
        </div>
        <div className="card-child">
          <Card
            icon={<FaExclamation size={80}/>} // Pass the 'X' icon (you can replace with an SVG)
            title="No server storage"
            subtitle="Your Mixes, Your Privacy – Uploaded Today, Gone by Midnight!"
            variant="tertiary"
          />
        </div>
        <div className="card-child">
          <Card
            icon={<FaUser size={80}/>} // Pass the 'X' icon (you can replace with an SVG)
            title="No membership"
            subtitle="Master Tracks, No Commitments"
            variant="tertiary"
          />
        </div>
      </div>

      <div className="landing-page-child-2">
        <Card
          icon={<FaLaptop size={80}/>} // Pass the 'X' icon (you can replace with an SVG)
          title="What happens next"
          subtitle="Each uploaded track is analyzed to enhance key features, with AI filling gaps and adding a touch of magic to perfect your mix!"
          variant="tertiary"
        />
      </div>
    </div>
    )
}
